import React from "react";
import { IconPreview } from "../../../../icons";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const shadowTokens = [
  { token: "--ds-shadow-sm", label: "Small" },
  { token: "--ds-shadow-md", label: "Medium" },
  { token: "--ds-shadow-lg", label: "Large" },
];

function ShadowToken({ item }) {
  return (
    <div className="ds-docs-shadow-token">
      <div className="ds-docs-shadow-token__preview" style={{ boxShadow: `var(${item.token})` }} aria-hidden="true" />
      <div className="ds-docs-shadow-token__content">
        <code>{item.token}</code>
        <span>{item.label}</span>
      </div>
    </div>
  );
}

export default function ShadowsDocs() {
  return (
    <DocsSectionCard title="Shadows">
      <div className="ds-docs-spotlight-grid ds-docs-spotlight-grid--shadows">
        <DocsPreviewPanel label="Tokens" icon={IconPreview}>
          <div className="ds-docs-preview-surface ds-docs-shadow-sheet">
            {shadowTokens.map((item) => (
              <ShadowToken key={item.token} item={item} />
            ))}
          </div>
        </DocsPreviewPanel>

        <DocsNiceToKnow
          intro="Shadows nur dezent einsetzen."
          items={["Cards haben keinen Shadow.", "Für normale Flächen reicht Border + Surface.", "Starke Shadows nur für klare Overlays verwenden."]}
        />
      </div>
    </DocsSectionCard>
  );
}
